import { formatNumber } from '@angular/common';
import {
  checkDefined,
  getGenericLabel
} from '@com-delta-idp/mnx-skymiles-shared';
import { EntryItem, Value } from '@com-delta-omnichannel/aura';
import { TYPE } from '../models';
import { Categories, MqdSummary } from '../models/api/content-api.interfaces';
import {
  CurrentYearDashboardEntity,
  EarnsSummaryResponse
} from '../models/api/earns-summary.interfaces';
import {
  findActivity,
  getActivityId,
  getSubTitle,
  getTitle,
  getTooltipAriaLabel
} from './earns-summary-helper.utils';

export const getValues = (
  category: Categories,
  activity: CurrentYearDashboardEntity
): Value[] => {
  const values: Value[] = [];

  if (
    activity &&
    activity.categorySummarizedBalances &&
    activity.categorySummarizedBalances[0].balanceAmt
  ) {
    values.push({
      amount: `${TYPE.CURRENCY_SYMBOL}${formatNumber(
        Number(activity.categorySummarizedBalances[0].balanceAmt?.toString()),
        TYPE.LOCALE,
        TYPE.DIGITS_INFO
      )}`,
      currency: ''
    });
  } else {
    values.push({
      amount: '--',
      currency: ''
    });
  }

  return values;
};

export const getToggleValues = (aem: MqdSummary): EntryItem => {
  return {
    content: getGenericLabel(aem.title, ''),
    state: '',
    icon: '',
    value: [
      {
        amount: '',
        currency: ''
      }
    ],
    border: 'none',
    ariaLabel: {
      icon: ''
    }
  };
};

export const getActivityEntryItem = (
  aemCategory: Categories,
  activity: CurrentYearDashboardEntity,
  index?: number
): EntryItem[] => {
  const activityValues: EntryItem[] = [];
  const result: EntryItem = {
    id: getActivityId(aemCategory, index),
    content: getGenericLabel(
      getTitle(activity),
      getSubTitle(activity, aemCategory)
    ),
    state: '',
    icon: aemCategory.logoSrc,
    value: getValues(aemCategory, activity),
    border: 'none',
    ariaLabel: getTooltipAriaLabel(aemCategory.tooltip, activity),
    info: aemCategory.tooltip,
    action: {
      label: checkDefined(aemCategory.description),
      url:
        activity && activity.activityCnt === 0
          ? aemCategory.actionUrl || ''
          : ''
    }
  };
  activityValues.push(result);
  return activityValues;
};

export const findCard = (
  activities: EarnsSummaryResponse,
  categoryCode: string
): boolean => {
  return !!activities.currentYearDashboard?.find((activity) => {
    return activity.categoryCode === categoryCode &&
      'cardTypeCode' in activity.categorySummarizedBalances[0]
      ? true
      : false;
  });
};

export const addEntryItem = (
  aem: MqdSummary,
  activities: EarnsSummaryResponse,
  countryCode: string,
  categoryCode: string,
  country: string,
  categoryType: string
): EntryItem[] => {
  let activityValues: EntryItem[] = [];

  if (!findCard(activities, categoryCode) && countryCode === country) {
    const activity = findActivity(activities, categoryCode);
    aem.categories.forEach((category) => {
      if (category.type === categoryType) {
        activityValues = [
          ...activityValues,
          ...getActivityEntryItem(category, activity[0])
        ];
      }
    });
  }
  return activityValues;
};

export const hasActivity = (
  activity: CurrentYearDashboardEntity,
  category: Categories
): boolean => {
  return activity.cardTypeCode
    ? activity.cardTypeCode === category.type
    : activity.categoryCode === category.code;
};
